import {api} from "../api";

/*
 * Ce service gère les fonctions relatives à la facutration et prix. Généralement utilisé dans 
 * achat-forfait et boutique
 */

export function factureTirage(facture) {
    return api.post("Facturation/FactureTirage", JSON.stringify(facture));
}

export function GetInfoBilletEtFlagImprimer(idFacture, idProduit) {
    if (idFacture.includes(":"))
        idFacture = idFacture.split(":")[1];

    return api.get(`Facturation/${ idFacture }/GetInfoBilletEtFlagImprimer?idProduit=${ idProduit }`);
}

export function GetNbBilletsImprimer(idProduit) {
    return api.get(`Facturation/GetNbBilletImprimer?idProduit=${ idProduit }`);
}